<figure
  groovePullquote
  variant="card"
  size="md"
  class="funnel-trust"
  aria-label="Student testimonial"
>
  <blockquote class="funnel-trust-quote">{{ quote().text }}</blockquote>
  <figcaption class="funnel-trust-cite">
    {{ quote().author }},
    <a [routerLink]="'/bass-lessons/testimonials'">more from students &rarr;</a>
  </figcaption>
</figure>
